import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

const NotificationDropdown = () => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="mdi mdi-bell" />
          {/* <span className="badge bg-danger rounded-pill">3</span> Indicador número de notificaciones*/}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0">Notificaciones</h6>
              </Col>
              <div className="col-auto">
                <a href="/notifications" className="small">
                  Ver todas
                </a>
              </div>
            </Row>
          </div>

          <SimpleBar style={{ height: "auto" }}>
            <Link to="" className="text-reset notification-item d-block">
              <div className="d-flex">
                <div className="avatar-xs me-3">
                  <span className="avatar-title bg-success rounded-circle font-size-16">
                    <i className="bx bx-badge-check" />
                  </span>
                </div>
                <div className="flex-1">
                  <h6 className="mt-0 mb-1">Notificación 1</h6>
                  <div className="font-size-12 text-muted">
                    <p className="mb-1">
                      Esto es un ejemplo para una notificación
                    </p>
                    <p className="mb-0">
                      <i className="mdi mdi-clock-outline" /> Hace 3 min
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </SimpleBar>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default NotificationDropdown;
